import React, { Component } from 'react';

class LoggedOut extends Component {
    
    render(){
        if (sessionStorage.getItem('email') === ""){
            return(
            <div className="container">
                <div className="alert alert-success mt-4">
                    You have successfully logged out!
                </div>
                <a href="/" className="btn btn-info">Click to log back in.</a>
            </div>
        )
        }else{
            return(
                <div className="container">
                    <div className="alert alert-danger mt-4">
                        You have not logged out yet! <br />
                        Please click log out from the navigation bar
                    </div>
                    <a href="/" className="btn btn-info">Back to home page</a>
                </div>
            )
        }
        
    }
}

export default LoggedOut;